/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
// import LanguageStrings from '../../../i18n/locales'

// const AddDeviceStrings = LanguageStrings().DeviceManagementCollectionStrings.AddDeviceComponent

const ZUpdateDeviceApiResponse = z.object({
  id: z.string().optional(),
  asset_id: z.string().optional(),
  name: z.string()
})

export interface UpdateDevicePutRequest {
  type?: string
  id?: string
  name: string
  device_tag?: string
  serial_number: string | null
  application_type: string
  latitude: string | number
  longitude: string | number
  slave_id: string
  asset_type_id?: string
  asset_model_id?: string
  asset_category_id?: string
  parent_asset_id?: string
  site_id?: string
  modem_id?: string
  port?: string
  isPollingEnabled?: boolean
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZUpdateDeviceApiResponse,
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type UpdateDeviceApiResponse = z.infer<typeof ZUpdateDeviceApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function updateDevice (
  updateDevicePutRequest: UpdateDevicePutRequest,
  onSuccess: (successResponse: UpdateDeviceApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets'

  interceptedAxios
    .put(url, updateDevicePutRequest, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
